// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Webapi from "@cardoc/frontend-common/src/bindings/Webapi.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactQuery from "@tanstack/react-query";
import * as ReactQueryDevtools from "@tanstack/react-query-devtools";

function make() {
  return new ReactQuery.QueryClient({
              defaultOptions: {
                queries: {
                  staleTime: 60000
                }
              }
            });
}

var browserQueryClient = {
  contents: undefined
};

function get() {
  if (Webapi.Dom.isBrowser()) {
    if (Core__Option.isNone(browserQueryClient.contents)) {
      browserQueryClient.contents = Caml_option.some(make());
    }
    return browserQueryClient.contents;
  } else {
    return Caml_option.some(make());
  }
}

var QueryClient = {
  make: make,
  browserQueryClient: browserQueryClient,
  get: get
};

function Providers(props) {
  return JsxRuntime.jsxs(ReactQuery.QueryClientProvider, {
              client: get(),
              children: [
                props.children,
                JsxRuntime.jsx(ReactQueryDevtools.ReactQueryDevtools, {
                      initialIsOpen: false
                    })
              ]
            });
}

var make$1 = Providers;

export {
  QueryClient ,
  make$1 as make,
}
/* react/jsx-runtime Not a pure module */
